import React from 'react'

import ReviewWidget from 'Components/Blocks/ReviewWidget'
import { Divider, Row } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

import { SOCIALS } from './constants'
import { Container, StyledLink } from './styles'

function FooterSocials() {
  const { isMobile } = useResponsiveLayout()

  return (
    <Container
      alignItems={['flex-start', 'flex-start', 'flex-start', 'center']}
      flexDirection={['column', 'column', 'column', 'row']}
    >
      <Row gap={5}>
        {SOCIALS.map(item => (
          <StyledLink
            aria-label={item.label}
            href={item.link}
            key={item.id}
            rel="noopener noreferrer"
            target="_blank"
          >
            {item.icon}
          </StyledLink>
        ))}
      </Row>

      {!isMobile && <Divider height="16px" invertedSlight />}

      <ReviewWidget />
    </Container>
  )
}

export default FooterSocials
